import styled from "styled-components";
import { secondaryColor } from "../../../config";

export const BackToAdminWrapper = styled.button`
  
`;
export const ProfileView = styled.div`
  display: block;
  background-color: var(--app-surface) !important;
  color: var(--app-text);
  box-shadow: var(--bs-dropdown-box-shadow, 0 0 50px 0 rgba(82, 63, 105, 0.15));

  .menu-content,
  .fw-bold,
  .menu-title,
  .menu-link {
    color: var(--app-text);
  }

  .text-muted,
  .fw-semibold.text-muted {
    color: var(--app-text-muted) !important;
  }

  .separator {
    border-bottom-color: var(--app-border) !important;
  }
`;
